import { recorderFmc } from '@/tauri/controller/recording';
import { logger } from '@/utils/logger/logger';
import { pTimeout } from '@heidi/utils';
import type { IntlShape } from 'react-intl';
import { showBackupExtractionFailedToast } from './backupExtractionFailedToast';

const PRESERVE_TIMEOUT_MS = 60000;

// Best-effort: extract the stale recording's WAVs into its own session's
// local audio folder (Rust still holds the stale session id) so the audio
// survives the WAV truncation in start(). Aborting instead would not protect
// it, as the recorder is already stopped. A failure toasts, since the start
// that follows overwrites the old audio.
export const preserveStaleRecorderAudio = async (sessionId: string, intl: IntlShape) => {
  try {
    const backupPath = await pTimeout(recorderFmc.get_backup_file(), PRESERVE_TIMEOUT_MS);
    logger.info('DESKTOP_RECORDING_STALE_AUDIO_PRESERVED', { sessionId, backupPath });
  } catch (backupError) {
    logger.error('DESKTOP_RECORDING_STALE_AUDIO_PRESERVE_FAILED', {
      sessionId,
      error: backupError instanceof Error ? backupError.message : String(backupError),
    });
    showBackupExtractionFailedToast(intl);
  }
};
